import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  ModalController,
  Loading,
  ViewController,
  AlertController,
} from "ionic-angular";
/* Models */
import { SalesrepModel } from "../../models/user/salesrep.model";
/* Filters & Services */
import { UtilService } from "../../services/util.service";
import * as _ from "lodash";
import { ModalAction } from '../../enums/modalaction.enum';

@IonicPage()
@Component({
  selector: "salesrep",
  templateUrl: "salesrep.html",
})
export class Salesrep {
  loading: Loading;
  searchTerm: string = "";
  salesrepList: SalesrepModel[];
  salesrepListCopy: SalesrepModel[];
  selectedSalesrep: SalesrepModel;
  isAllowDismiss: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private viewCtrl: ViewController,
    private alertCtrl: AlertController,
    private util: UtilService,
  ) {
    this.salesrepList = _.clone(navParams.get("data"));
    this.isAllowDismiss = navParams.get("isAllowDismiss");
    this.salesrepListCopy = _.clone(this.salesrepList);
  }

  selectSalesrep(value: SalesrepModel) {
    this.selectedSalesrep = value;
  }

  proceed() {
    if (this.selectedSalesrep === undefined) {
      this.util.displayAlert(
        this.alertCtrl,
        "Salesrep not selected",
        "Please select a salesrep"
      );
      return;
    }
    this.salesrepList.length = 0;
    this.salesrepList.push(this.selectedSalesrep);

    this.viewCtrl.dismiss({ action: ModalAction.Proceed, salesrep: this.salesrepList });
  }

  dismiss() {
    this.viewCtrl.dismiss({ action: ModalAction.Cancel });
  }

  search(keyword): void {
    this.salesrepList = this.salesrepListCopy.filter((value) => {
      return (
        value.salesrep_code.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
        value.salesrep_name.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
        value.team_code.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
        value.team_name.toLowerCase().indexOf(keyword.toLowerCase()) > -1
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/salesrep/salesrep.ts